import { StructuredStorageSlots } from '../../constants';
import { Helper } from '../Helper';
export class HandlePrefixArrayStructuredStorageHelper extends Helper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitOp(node, 'DUP');
        sb.emitPushInt(node, StructuredStorageSlots.prefix);
        sb.emitOp(node, 'PICKITEM');
        sb.emitOp(node, 'ROT');
        sb.emitOp(node, 'TUCK');
        sb.emitSysCall(node, 'Neo.Runtime.Serialize');
        sb.emitOp(node, 'CAT');
        sb.emitOp(node, 'ROT');
        sb.emitOp(node, 'DUP');
        sb.emitPushInt(node, StructuredStorageSlots.prefixArray);
        sb.emitOp(node, 'OVER');
        sb.emitPushInt(node, StructuredStorageSlots.prefixArray);
        sb.emitOp(node, 'PICKITEM');
        sb.emitHelper(node, options, sb.helpers.cloneArray);
        sb.emitOp(node, 'DUP');
        sb.emitPushInt(node, 6);
        sb.emitOp(node, 'ROLL');
        sb.emitOp(node, 'APPEND');
        sb.emitOp(node, 'SETITEM');
        sb.emitOp(node, 'TUCK');
        sb.emitPushInt(node, StructuredStorageSlots.prefix);
        sb.emitOp(node, 'ROT');
        sb.emitOp(node, 'SETITEM');
    }
}

//# sourceMappingURL=HandlePrefixArrayStructuredStorageHelper.js.map
